import { render, staticRenderFns } from "./LoginError.vue?vue&type=template&id=fa1781e0&lang=pug&"
import script from "./LoginError.vue?vue&type=script&lang=js&"
export * from "./LoginError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports